import api from './api';

/**
 * Authentication Service
 * Handles all authentication-related API calls
 */

export const login = async (username, password) => {
  try {
    const response = await api.post('/auth.php/login', {
      username,
      password
    });

    // Handle both response formats: status: 'success' or success: true
    if ((response.status === 'success' || response.success === true) && response.token) {
      // Store token and user data
      localStorage.setItem('auth_token', response.token);
      // Extract company_id from user object or response
      const companyId = response.user?.company_id || response.company_id;
      if (companyId) {
        localStorage.setItem('company_id', companyId);
      }
      if (response.user) {
        localStorage.setItem('user', JSON.stringify(response.user));
      }
      return response;
    } else if (response.token) {
      // Fallback: if token exists, store it anyway
      localStorage.setItem('auth_token', response.token);
      // Extract company_id from user object or response
      const companyId = response.user?.company_id || response.company_id;
      if (companyId) {
        localStorage.setItem('company_id', companyId);
      }
      if (response.user) {
        localStorage.setItem('user', JSON.stringify(response.user));
      }
      return response;
    } else {
      throw new Error(response.message || response.error || 'Login failed');
    }
  } catch (error) {
    throw error;
  }
};

export const register = async (userData) => {
  try {
    const response = await api.post('/auth.php/register', userData);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getUsers = async () => {
  try {
    const response = await api.get('/auth.php/users');
    return response;
  } catch (error) {
    throw error;
  }
};

export const logout = async () => {
  try {
    // Clear local storage
    localStorage.removeItem('auth_token');
    localStorage.removeItem('company_id');
    localStorage.removeItem('user');
    sessionStorage.removeItem('auth_token');

    // Call logout endpoint if available
    try {
      await api.post('/auth.php', { action: 'logout' });
    } catch (e) {
      // Ignore logout endpoint errors
    }
  } catch (error) {
    throw error;
  }
};

export const validateToken = async () => {
  try {
    const response = await api.get('/auth.php', {
      params: { action: 'validate' }
    });
    return response;
  } catch (error) {
    // Token is invalid, clear storage
    localStorage.removeItem('auth_token');
    localStorage.removeItem('company_id');
    localStorage.removeItem('user');
    throw error;
  }
};

export const getCurrentUser = () => {
  const userStr = localStorage.getItem('user');
  if (userStr) {
    try {
      return JSON.parse(userStr);
    } catch (e) {
      return null;
    }
  }
  return null;
};

export const getToken = () => {
  return localStorage.getItem('auth_token') || sessionStorage.getItem('auth_token');
};

export const isAuthenticated = () => {
  return !!getToken();
};

